import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHHorarioUpd = async (credentials, data) => {
  const body = {
    service: "RNHHorarioUpd",
    params: {
      rnhHorarioId: data?.id || null,
      rnhHorarioCod: data?.cod || null,
      rnhHorarioNombre: data?.nombre || null,
      rnhHorarioTipo: data?.tipo || null,
      rnhHorarioFechaDesde: data?.desde || null,
      rnhHorarioFechaHasta: data?.hasta || null,
      rnhHorarioEsDefault: data?.default || null,
      rnhHorarioDescripcion: data?.descripcion || null,
      rnhHorarioVersion: data?.version ?? null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};

